const _excluded = ["className", "children", "disabled", "size", "skin", "noPadding", "cursorDefault", "intent", "tooltip"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import cn from 'classnames';
import { useIntentBehavior } from "../IntentBehavior";
import { Tooltip } from "../Tooltip";
import styles from "./IconButton.module.scss";
export const IconButton = /*#__PURE__*/React.forwardRef(function IconButton(props, ref) {
  const {
    className,
    children,
    disabled,
    size = 'medium',
    skin = 'standard',
    noPadding,
    cursorDefault,
    intent,
    tooltip
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  const testid = props['data-testid'];
  const {
    getDisabled,
    getTooltip
  } = useIntentBehavior();
  const disabledFromIntent = intent ? getDisabled(intent) : false;
  const tooltipFromIntent = intent ? getTooltip(intent) : null;
  const hasTooltip = !!(tooltip !== null && tooltip !== void 0 && tooltip.title) || !!tooltipFromIntent;
  const button = /*#__PURE__*/React.createElement("button", _extends({
    ref: ref,
    disabled: disabledFromIntent || disabled,
    className: cn(styles.root, styles["".concat(skin, "Skin")], styles["".concat(size, "Size")], {
      [styles.noPadding]: noPadding,
      [styles.cursorDefault]: cursorDefault
    }, !hasTooltip && className)
  }, rest), children);
  return hasTooltip ? /*#__PURE__*/React.createElement(Tooltip, tooltip || {
    placement: 'top',
    title: tooltipFromIntent
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.wrapper, className),
    "data-testid": testid && "".concat(testid, "-wrapper")
  }, button)) : button;
});